<template>
  <div class="mt-6 flex items-center justify-end flex-wrap gap-3">
    <nav class="flex items-center gap-2">
      <button
          v-for="p in pages"
          :key="p"
          @click="$emit('page-change', p)"
          :class="[
          'h-12 w-12 border !border-black focus:outline-none focus:ring-0',
          p===page ? '!bg-black text-white !border !border-black' : 'text-neutral-800 hover:!bg-black hover:text-white hover:!border-black'
        ]"
          style="font-size: 20px;"
      >{{ p }}
      </button>
    </nav>
    <div v-if="showPerPage" class="flex items-center gap-2 text-[20px] text-neutral-700 relative">
      <span class="whitespace-nowrap">{{ t('pagination.itemsPerPage') }}</span>
      <div class="relative">
        <select :value="perPage" @change="$emit('per-page-change', Number(($event.target && $event.target.value) || perPage))"
                class="h-10 px-3 pr-8 border border-black bg-white text-sm font-bold uppercase  focus:ring-0 focus:border-black appearance-none">
          <option v-for="opt in perPageOptions" :key="opt" :value="opt">{{ opt }}</option>
        </select>
        <svg class="absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 pointer-events-none" fill="none"
             stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
        </svg>
      </div>
    </div>
  </div>
  
</template>

<script setup>
import { t } from '../i18n'
const props = defineProps({
  page: { type: Number, default: 1 },
  pages: { type: Array, default: () => [] },
  showPerPage: { type: Boolean, default: false },
  perPage: { type: Number, default: 20 },
  perPageOptions: { type: Array, default: () => [10,20,50,100] },
})
defineEmits(['page-change','per-page-change'])
</script>
